import React from 'react';
import { connect } from 'react-redux';

// Actions
import {
    requestLoadTimesheet,
    canceledLoadTimesheet
} from '../../../../../../services/timesheet/actions';

interface Props {
    requestLoadTimesheet: Function;
    canceledLoadTimesheet: Function;
    timesheetId: number;
}

export class TimesheetRequest extends React.PureComponent<Props> {
    componentDidMount() {
        const { timesheetId } = this.props;
        this.props.requestLoadTimesheet(timesheetId);
    }

    componentWillUnmount() {
        this.props.canceledLoadTimesheet();
    }

    render() {
        return null;
    }
}

export default connect(
    null,
    {
        requestLoadTimesheet,
        canceledLoadTimesheet
    }
)(TimesheetRequest);
